export { FromVector, createVector } from '../fromvector/fromVector';
export type { VectorObject } from '../fromvector/fromVector';
